import { PolicyCoverageEntity } from './policy-coverage-entity';

export class CertificateLobTemplateEntity {
  constructor({ id, coverages = [], formType }) {
    this.id = id;
    this.formType = formType;
    this.coverages = coverages.map(
      coverage => new PolicyCoverageEntity(coverage)
    );
  }
}
